import { mergeEnrollmentRow } from '../../../utils/enrollmentRowMerge';

export const mergeDealerPayload = (prev, payload) => mergeEnrollmentRow(prev, payload);
